import { v4 as uuidv4 } from 'uuid'
import { ImmutableLine3, ImmutableVector3 } from '@modugen/ui-toolkit'
import { TapelineCreateDTO, TapelineDTO, TapelineModifyDTO } from '@mutations'
import type { PlanTapelineConfig, Tapeline, TapelineInput, TapelineStyle } from './index'

export const DEFAULT_TAPLINE_STYLE: TapelineStyle = {
  color: '#000000',
  thickness: 1.5,
  lineStyle: 'solid',
}

export const DEFAULT_PLAN_CONFIG: PlanTapelineConfig = {
  // Tapelines are not storey-bound. Empty storeysForPlans is ignored at PDF export.
  storeysForPlans: [],
  planTypes: ['PositionPlan', 'StiffeningPlan', 'LoadPlan'],
}

const createDefaultPlanConfig = (): PlanTapelineConfig => ({
  storeysForPlans: [...DEFAULT_PLAN_CONFIG.storeysForPlans],
  planTypes: [...DEFAULT_PLAN_CONFIG.planTypes],
})

export const completeTapelineInput = (
  line: TapelineInput,
  activeFilterViewId: string,
): Tapeline => ({
  ...line,
  id: line.id || uuidv4(),
  filterViewId: line.filterViewId || activeFilterViewId,
  text: line.text,
  style: {
    ...DEFAULT_TAPLINE_STYLE,
    ...(line.style || {}),
  },
  showLengthLabel: line.showLengthLabel ?? true,
  planConfig: line.planConfig ?? createDefaultPlanConfig(),
})

export const tapelineDtoToTapeline = (dto: TapelineDTO): Tapeline => {
  const start = new ImmutableVector3(dto.start.x, dto.start.y, dto.start.z)
  const end = new ImmutableVector3(dto.end.x, dto.end.y, dto.end.z)
  const line = new ImmutableLine3(start, end)

  return Object.assign(line, {
    id: dto.id,
    filterViewId: dto.filterViewId,
    text: dto.text ?? undefined,
    style: dto.style,
    showLengthLabel: dto.showLengthLabel,
    planConfig: dto.planConfig,
  })
}

export const tapelineToCreateDTO = (tapeline: Tapeline): TapelineCreateDTO => ({
  id: tapeline.id,
  start: { x: tapeline.start.x, y: tapeline.start.y, z: tapeline.start.z },
  end: { x: tapeline.end.x, y: tapeline.end.y, z: tapeline.end.z },
  filterViewId: tapeline.filterViewId,
  text: tapeline.text ?? null,
  style: tapeline.style,
  showLengthLabel: tapeline.showLengthLabel,
  planConfig: tapeline.planConfig,
})

export const tapelineToModifyDTO = (tapeline: Tapeline): TapelineModifyDTO => {
  const { id: _id, ...dto } = tapelineToCreateDTO(tapeline)
  return dto
}
